// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '', // 从本地存储读取 TOKEN（如果存在）
        userId: localStorage.getItem('userId') || '', // 从本地存储读取 userId（如果存在）
    },
    mutations: {
        // 设置 TOKEN
        setToken(state, token) {
            state.token = token
            // 将 TOKEN 存储到本地存储，以便持久化
            localStorage.setItem('token', token)
        },
        // 清除 TOKEN
        clearToken(state) {
            state.token = ''
            localStorage.removeItem('token')
        },

        // 设置 userId
        setUserId(state, userId) {
            state.userId = userId
            // 将 userId 存储到本地存储，以便持久化
            localStorage.setItem('userId', userId)
        },
        // 清除 userId
        clearUserId(state) {
            state.userId = ''
            localStorage.removeItem('userId')
        }
    },
    actions: {
        // 登录时设置 TOKEN 和 userId
        login({ commit }, { token, userId }) {
            commit('setToken', token)
            commit('setUserId', userId)
        },
        // 登出时清除 TOKEN 和 userId
        logout({ commit }) {
            commit('clearToken')
            commit('clearUserId')
        }
    },
    getters: {
        getToken: (state) => state.token,
        getUserId: (state) => state.userId,
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})
